import { agx, rodobens, jive } from './projects'
// import variables from './variables'

const layout = (function(){
  let hostname = window.location.hostname.split('.')

  if(hostname.length === 2 || window.location.hostname === 'seuimovel.agxsoftware') return agx

  let [ , slug, ] = hostname

  if(slug === 'rodobens') return rodobens

  if(slug === 'jive') return jive

  // if(['development', 'local'].includes(variables.env)) return rodobens

  return agx
})()

export { layout }